import { toast as sonnerToast } from "sonner";

/** Errors linger long enough to actually read (sonner's default ~4s was
 * measured too fast during the 2026-07-11 quota-403 incident). Explicit
 * per-call durations still win. */
const ERROR_DURATION_MS = 12_000;

type ErrorArgs = Parameters<typeof sonnerToast.error>;

function errorWithDuration(message: ErrorArgs[0], options?: ErrorArgs[1]) {
  return sonnerToast.error(message, {
    duration: ERROR_DURATION_MS,
    ...options,
  });
}

/** App-wide toast entry point. Same surface as sonner's `toast`, except
 * `toast.error` defaults to a markedly longer duration than success/info.
 * Import from here, not from "sonner" (the root <Toaster> is the only
 * exception).
 *
 * Implemented as a Proxy so every other member stays LATE-BOUND to sonner —
 * tests that vi.spyOn(sonner.toast, "success") after module init still
 * intercept calls (an Object.assign copy would pin pre-spy references). */
export const toast: typeof sonnerToast = new Proxy(sonnerToast, {
  get(target, prop, receiver) {
    if (prop === "error") return errorWithDuration;
    return Reflect.get(target, prop, receiver);
  },
}) as typeof sonnerToast;
